
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  name: 'PopLayout',
  components: {}
})
export default class PopLayout extends Vue {
  @Prop({ default: false, required: true }) visible: boolean
  @Prop({ default: false }) escToClose: boolean

  get innerVisible() {
    return this.visible
  }

  set innerVisible(v: boolean) {
    this.$emit('update:visible', v)
  }

  @Emit('closed')
  onClosed() {}

  @Emit('opened')
  onOpened() {}

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
